// extracted by mini-css-extract-plugin
export default {"main-document":"EmptyViewer_main-document__vnVB-","main-document-detail":"EmptyViewer_main-document-detail__Wr5eM","empty-div-viewer":"EmptyViewer_empty-div-viewer__9mZzq"};